import { useQuery } from '@pankod/refine-core';
import { useFeatureFlag } from 'hooks/useFeatureFlags';
import { getErpOption } from 'services/erp-options';
import { parseVatRatePercent, VAT_RATE_OPTION } from 'utilities/sale-vat';

// The organization VAT percent while `sale.vatRate` is on for this tenant, else 0. The API copies
// the same rate onto every new sale, so screens use this only to show prices and totals.
export const useOrganizationVatRate = () => {
  const vatRateEnabled = useFeatureFlag('sale.vatRate');
  const { data: vatRateOption } = useQuery(
    ['erpOption', VAT_RATE_OPTION],
    () => getErpOption(VAT_RATE_OPTION),
    { enabled: vatRateEnabled, staleTime: 60 * 1000 },
  );
  return {
    vatRateEnabled,
    vatRatePercent: vatRateEnabled ? parseVatRatePercent(vatRateOption) : 0,
  };
};
